export const MUSCLE_LABELS: Record<string, string> = {
  NECK: 'neck',
  BICEPS: 'biceps',
  TRAPS: 'traps',
  SHOULDERS: 'shoulders',
  LOWER_BACK: 'lower back',
  HAMSTRINGS: 'hamstrings',
  FOREARM: 'forearm',
  CALVES: 'calves',
  CHEST: 'chest',
  ABDOMINAL: 'abdominal',
  OBLIQUES: 'obliques',
  HIP_FLEXORS: 'hip flexors',
  ADDUCTORS: 'adductors',
  ABDUCTORS: 'abductors',
  MIDDLE_BACK: 'middle back',
  LATS: 'lats',
  TRICEPS: 'triceps',
  QUADRICEPS: 'quadriceps',
  GLUTES: 'glutes',
};

export const EQUIPMENT_LABELS: Record<string, string> = {
  BODY_ONLY: 'Body Only',
  DUMBBELL: 'Dumbbell',
  'E-Z_BAR': 'E-Z Curl Bar',
  OTHER: 'Other',
  MACHINE: 'Machine',
  BANDS: 'Bands',
  MEDICINE_BALL: 'Medicine Ball',
  ROLL: 'Foam Roll',
  BARBELL: 'Barbell',
  EXERCISE_BALL: 'Exercise Ball',
  NONE: 'None',
  KETTLEBELLS: 'Kettlebells',
  CABLE: 'Cable',
  SLED: 'Sled',
  TRAP_BAR: 'Trap Bar',
  ROWER: 'Rower',
  JUMP_ROPE: 'Jump Rope',
  BATTLE_ROPES: 'Battle Ropes',
  BOX: 'Box',
  SANDBAG: 'Sandbag',
};

export const EXERCISE_TYPE_LABELS: Record<string, string> = {
  CARDIO: 'Cardio',
  OLYMPIC_WEIGHTLIFTING: 'Olympic Weightlifting',
  POWERLIFTING: 'Powerlifting',
  STRENGTH: 'Strength',
  STRETCHING: 'Stretching',
  STRONGMAN: 'Strongman',
  PLYOMETRICS: 'Plyometrics',
  FUNCTIONAL: 'Functional',
};

export const PROFICIENCY_LEVEL_LABELS: Record<string, string> = {
  BEGINNER: 'Beginner',
  INTERMEDIATE: 'Intermediate',
  ADVANCED: 'Advanced',
};

export const INSTRUCTION_TYPE_LABELS: Record<string, string> = {
  REPS: 'Reps',
  DURATION: 'Duration (sec.)',
};

export const INSTRUCTION_UNIT_LABELS: Record<string, string> = {
  REPS: 'RM',
  DURATION: 'sec',
  MINUTES: 'min',
};

export const LOAD_LABELS: Record<string, string> = {
  REPS: 'Amount of reps',
  DURATION: 'Amount of seconds',
};
